import { Configuration, PopupRequest } from "@azure/msal-browser";

// Environment variables for Azure Entra ID configuration
const TENANT_ID = process.env.REACT_APP_AZURE_TENANT_ID || "";
const CLIENT_ID = process.env.REACT_APP_AZURE_CLIENT_ID || "";
const AUTHORITY = `https://login.microsoftonline.com/${TENANT_ID}`;

export const msalConfig: Configuration = {
  auth: {
  clientId: CLIENT_ID,
    authority: AUTHORITY,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage", // Cache location
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  }
};

// Scopes for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest: PopupRequest = {
  scopes: ["User.Read"],
  prompt: "select_account"
};

// API configuration for backend access
export const apiConfig = {
  // The backend API scope 
  scopes: [`api://${CLIENT_ID}/user_access`],
  uri: process.env.REACT_APP_API_URL || "http://localhost:8000"
};

// Admin role configuration
export const ADMIN_ROLE = "AdminUI.Admin";

export const validateConfig = (): boolean => {
  if (!TENANT_ID || !CLIENT_ID) {
    //TODO: for debugging. Remove this.
    console.error("Azure Entra ID configuration is incomplete. Please check environment variables:");
    console.error("- REACT_APP_AZURE_TENANT_ID");
    console.error("- REACT_APP_AZURE_CLIENT_ID");
    return false;
  }
  return true;
};